import { reactive } from 'vue';

const editBreakState = reactive({
  editBreakForm: false,
  addBreakForm: false,
  breakId: null as any,
  emptyField: false,
});

export { editBreakState };
